import interfaceManagementCapability from './content/interface-management-capability.md?raw'
import { buildFileWriteNarration, buildStepNarration } from './stepNarrationCopy.js'
import { SITE_ROOT } from './websiteCrmDemoContent.part03.js'

export function writeStep(relPath, content, durationMs = 3200, stepNarration, nextRelPath, narrationIndex = 0) {
  return {
    durationMs,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: `${SITE_ROOT}/${relPath}`,
      content,
    },
    result: { ok: true },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: stepNarration ?? buildFileWriteNarration(relPath, nextRelPath, narrationIndex),
  }
}

export const WEBSITE_CRM_AI_LOG_STEPS_INITIAL = [
  {
    durationMs: 2000,
    actionName: 'Loaded interface-management instructions',
    arguments: 'path: /DOSense/system/capabilities/interface-management/CAPABILITY.md',
    result: interfaceManagementCapability,
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Interface-management instructions are loaded for the HTML preview panel',
      'scaffolding the nexus-b2b-site project folder',
      0,
    ),
  },
  {
    durationMs: 8400,
    actionName: 'Finished running command',
    arguments: {
      command: `mkdir -p ${SITE_ROOT}/{assets,js,tests}`,
    },
    result: { log: 'created assets/, js/, tests/', exitCode: 0 },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'The nexus-b2b-site/ folder structure is ready',
      'writing the main index.html procurement site',
      1,
    ),
  },
]
